import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	doRecoverAccountWithTypeRequest,
	requestAccountRecoverWithTypeME,
} from "../../../store/modules/recoverPassword/actions";

import ValidationPinCode from "../../../components/ValidationPinCode";
import { hideCharactersEmail } from "../../../utils";

export default function ConfirmPinCodeEmail(props) {
	const { recoverType, recoverData } = props;

	const dispatch = useDispatch();

	const { pinCodeFail, accountRecoverWithTypeResponse } = useSelector((state) => state.recoverPassword);

	const [tokenRecaptcha, setTokenRecaptcha] = useState({});
	const [recoverTime, setRecoverTime] = useState(30);
	const [codeResendControl, setCodeResendControl] = useState({
		isResendCode: false,
		last: "",
	});

	useEffect(() => {
		if (Object.keys(accountRecoverWithTypeResponse).length) {
			setRecoverTime(accountRecoverWithTypeResponse.seconds);
		}
	}, [accountRecoverWithTypeResponse]);

	useEffect(() => {
		if (Object.values(tokenRecaptcha).length && codeResendControl.isResendCode) {
			dispatch(
				requestAccountRecoverWithTypeME(
					{
						baseInfoType: recoverType,
						baseInfoVl: recoverData,
						recoverChannel: "email",
						operatingSystem: "WEB",
					},
					tokenRecaptcha
				)
			);

			setCodeResendControl((prev) => ({
				...prev,
				isResendCode: false,
			}));
		}
	}, [tokenRecaptcha, codeResendControl]);

	function resendPinCode(type) {
		setCodeResendControl({
			isResendCode: true,
			last: type,
		});
	}

	function tokenConfirmation(pin) {
		dispatch(
			doRecoverAccountWithTypeRequest({
				token: pin,
				type: "email",
				value: recoverData,
			})
		);
	}

	function recoverTypeFormatted(type) {
		const action = {
			email: () => "e-mail",
		};

		return action[type]();
	}

	return (
		<ValidationPinCode
			title="Insira o código enviado para seu e-mail"
			subtitle={`Enviado <span style="color: var(--brand-primary)">por ${recoverTypeFormatted(recoverType)}</span> para ${hideCharactersEmail(recoverData)}.`}
			error={pinCodeFail}
			messageError="Código inválido, revise e tente novamente"
			onSubmit={(pin) => tokenConfirmation(pin)}
			onResendCode={resendPinCode}
			resendType={recoverType}
			seconds={recoverTime}
			setTokenRecaptcha={setTokenRecaptcha}
		/>
	);
}
